enum ActionsTypes {
    SET_SUBSCRIPTION_SUMMARY = 'SET_SUBSCRIPTION_SUMMARY',
    SET_MIX_SUMMARY = 'SET_MIX_SUMMARY',
}

export type ActionType = keyof typeof ActionsTypes;

export default ActionsTypes;
